export default class LanguageCacheName {
  static getLanguageList(): string {
    return "languageList";
  }
}
